@if (question(); as question) {

  @if (hasQuestionSetIntroduction(question)) {
    <div
      class="w-full max-w-4xl mx-auto mt-8 mb-6 border border-textbox-border rounded-[8px] px-5 py-4 bg-textbox-fill"
    >
      <p class="inter-300 text-[1rem] text-support-text text-center whitespace-pre-line">
        {{ question.questionSetIntroductionText }}
      </p>
    </div>
  }

  @if (isMobile()) {
    <div class="w-full bg-transparent mb-[28px]">
      <div class="w-full items-center text-center">
        @if (question.htmlText) {
          <div class="space-grotesk-600 text-[1.8rem] text-support-text text-center"
               [innerHTML]="question.htmlText"></div>
        } @else {
          <h1 class="space-grotesk-600 text-[1.8rem] text-support-text text-center">
            {{ question.text }}
          </h1>
        }
        @if (question.descriptionText) {
          <h2 class="inter-300 text-[1rem] text-support-text text-center">
            {{ question.descriptionText }}
          </h2>
        }
      </div>

      @if (imageUrls.length > 0) {
        <div>
          @for (imageUrl of imageUrls; track $index) {
            <div><img alt="" [src]="imageUrl" class="w-full"/></div>
          }
        </div>
      }

      @if (downloadableAttachments.length > 0) {
        <div class="flex flex-wrap gap-4 inter-300 text-support-text p-4">
          @for (attachment of downloadableAttachments; track $index) {
            <div (click)="downloadFile(attachment)"
                 class="cursor-pointer p-4 rounded-[10px] shadow-[0_0_5px_0_rgba(0,0,0,0.25)] text-support-text">{{ attachment.name }}
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="w-full bg-transparent text-neutral-content px-4 py-4 mt-8">
    @if (!isMobile()) {
        @if (question.htmlText) {
          <div class="space-grotesk-600 text-[1.8rem] text-support-text text-center mb-4"
               [innerHTML]="question.htmlText"></div>
        } @else {
          <h1 class="space-grotesk-600 text-[1.8rem] text-support-text text-center mb-4">
            {{ question.text }}
          </h1>
        }

        @if (question.descriptionText) {
          <h2 class="inter-300 text-[1rem] text-support-text text-center">
            {{ question.descriptionText }}
          </h2>
        }

        @if (imageUrls.length > 0) {
          @for (imageUrl of imageUrls; track $index) {
            <div>
              <img alt="" [src]="imageUrl" class="w-full" />
            </div>
          }
        }

        @if (downloadableAttachments.length > 0) {
          <div class="flex flex-wrap gap-4 inter-300 text-support-text">
            @for (attachment of downloadableAttachments; track $index) {
              <div (click)="downloadFile(attachment)"
                   class="cursor-pointer p-4 rounded-[10px] shadow-[0_0_5px_0_rgba(0,0,0,0.25)] text-support-text">{{ attachment.name }}
              </div>
            }
          </div>
        }
      }

      @switch (question.type) {
        @case (QuestionType.SingleChoice) {
          <h3 class="inter-300 text-[1rem] text-support-text text-center mb-12">
            Please select <span class="inter-300 italic">one</span> option
          </h3>
          @if (question.answerOptions; as answerOptions) {
            <div class="w-full max-w-2xl mx-auto">
              <div class="flex flex-col items-start gap-5">
                @for (option of answerOptions | orderBy: 'index':'asc'; track option.guid) {
                  <div class="w-full">
                    <label
                      [for]="'single-choice-' + option.guid"
                      class="group inline-flex cursor-pointer items-center gap-4 py-1"
                    >
                      <input
                        type="radio"
                        class="hidden-radio"
                        [id]="'single-choice-' + option.guid"
                        name="radio"
                        (change)="onSingleChoiceOptionChange(option.guid)"
                        [value]="option.guid"
                        [(ngModel)]="singleSelectOptionGuid"
                      />
                      <span
                        class="inline-flex items-center justify-center w-6 h-6 rounded-full flex-shrink-0 transition-colors duration-200 ring-2 ring-transparent group-hover:ring-kek-purple/20"
                        [class.bg-choice-option-checked]="
                          singleSelectOptionGuid === option.guid
                        "
                        [class.bg-choice-option-unchecked]="
                          singleSelectOptionGuid !== option.guid
                        "
                      ></span>
                      <span class="label-text inter-300 text-[1.25rem] text-support-text">
                        {{ option.text }}
                      </span>
                    </label>
                    @if (option.includeFreeTextInput) {
                      <textarea
                        type="text"
                        class="mt-3 ml-10 p-3 w-[calc(100%-2.5rem)] rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border disabled:opacity-50 disabled:cursor-not-allowed resize-none overflow-auto min-h-[80px] max-h-[200px]"
                        [disabled]="singleSelectOptionGuid !== option.guid"
                        [(ngModel)]="option.freeText"
                        (ngModelChange)="updateUserCanMoveToNextQuestion()"
                        rows="3"
                      ></textarea>
                    }
                  </div>
                }
              </div>
            </div>
          }
        }
        @case (QuestionType.MultipleChoice) {
          <h3 class="inter-300 text-[1rem] text-support-text text-center mb-12">
            Please select <span class="inter-300 italic">one or more</span> options
          </h3>
          @if (question.answerOptions; as answerOptions) {
            <div class="w-full flex justify-center">
              <div class="grid gap-3 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-4xl"
              >
              @for (option of answerOptions | orderBy: 'index':'asc'; track option.guid) {
                <div class="form-control w-full">
                  <label class="cursor-pointer label w-full flex items-start gap-4 px-4 py-3">
                    <input
                      type="checkbox"
                      class="hidden-checkbox"
                      name="multiSelectOption"
                      [value]="option.guid"
                      [checked]="-1 !== multiSelectOptionGuids.indexOf(option.guid!) ? 'checked' : ''"
                      (change)="updateMultiSelectList($event)"
                    />
                    <span class="inline-flex items-center justify-center w-6 h-6 rounded-full flex-shrink-0 transition-colors duration-200"
                          [ngClass]="-1 !== multiSelectOptionGuids.indexOf(option.guid!) ? 'bg-choice-option-checked' : 'bg-choice-option-unchecked'"></span>
                    <span class="ml-2 label-text w-full inter-300 text-[1.25rem] text-support-text">{{ option.text }}</span>
                  </label>
                </div>
              }
              </div>
            </div>
          }
        }
        @case (QuestionType.FreeText) {
          <h3 class="inter-300 text-[1rem] text-support-text text-center mb-12">Please write your answer below</h3>
          <div class="form-control">
            <textarea
              class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border resize-none overflow-auto min-h-[120px] max-h-[400px]"
              placeholder="Type here..."
              [(ngModel)]="freeText"
              [maxlength]="getMaxTextAreaLength()"
              [rows]="getRows()"
              (ngModelChange)="updateUserCanMoveToNextQuestion()"
            ></textarea>
            <label class="label">
              <span class="label-text-alt ml-auto inter-300 text-support-text">
                {{ freeText.length }}/{{ getMaxTextAreaLength() }}
              </span>
            </label>
          </div>
        }
        @case (QuestionType.RangeSelection) {
          <h3 class="inter-300 text-[1rem] text-support-text text-center mb-12">
            Please move the slider to the appropriate position
          </h3>
          <div class="form-control">
            <div class="flex w-full mb-2 mt-4 justify-between">
              @for (answerOption of question.answerOptions; track answerOption.guid) {
                <div
                  class="inter-300 text-[12px] md:text-[16px] inline-block min-w-[15px] text-center text-support-text">
                  {{ answerOption.text }}
                </div>
              }
            </div>
            @if (question.answerOptions) {
              <input
                type="range"
                min="0"
                [max]="question.answerOptions.length - 1"
                value="0"
                class="range w-full [&::-webkit-slider-thumb]:bg-range-thumb [&::-moz-range-thumb]:bg-range-thumb [&::-moz-range-progress]:bg-range-track"
                [(ngModel)]="rangeUpperBound"
                (pointerdown)="onRangeSelectionChange()"
                (keydown)="onRangeSelectionChange()"
                (input)="onRangeSelectionChange()"
                (change)="onRangeSelectionChange()"
              />
            }
          </div>
        }
        @case (QuestionType.Ranking) {
          <h3 class="inter-300 text-[1rem] text-support-text text-center mb-12">
            Please drag the answers to re-order them
          </h3>
          @if (question.answerOptions; as answerOptions) {
            <div class="w-full flex justify-center">
              <div cdkDropList (cdkDropListDropped)="drop($event)" class="answer-options-drag-list flex flex-col min-w-[80%] lg:min-w-[1/2]">
                @for (answerOption of answerOptions | orderBy: 'index':'asc'; track answerOption.guid) {
                  <div cdkDrag
                       class="answer-option-container mb-3 px-4 py-4 text-[1rem] inter-400 text-support-text bg-[#f3f2f3] dark:bg-neutral-form rounded-lg min-h-[48px] flex items-center justify-between cursor-grab active:cursor-grabbing whitespace-nowrap">
                    {{ answerOption.text }}
                    <span class="material-icons text-support-text opacity-60 ml-4 flex-shrink-0">drag_indicator</span>
                  </div>
                }
              </div>
            </div>
          }
        }
        @case (QuestionType.Date) {
          <h3 class="inter-300 text-[1rem] text-support-text text-center mb-12">Please enter date below</h3>
          <div class="form-control">
            <input
              class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border"
              type="date"
              [(ngModel)]="freeText"
              (ngModelChange)="updateUserCanMoveToNextQuestion()"
            >
          </div>
        }
      }

      <!-- TODO : Bring this back when multiple slider type supported by KQ
      @if (question.questionType === 'slider-multiple') {
        <h3 class="montserrat-light text-xl">
          Please move the sliders to the appropriate position.
        </h3>
        <div class="form-control" *ngFor="let slider of question.sliders">
          <label class="label">
            <span class="label-text-alt text-xl">
              {{ slider.min }}
            </span>
            <span class="label-text-alt text-xl">
              {{ slider.max }}
            </span>
          </label>
          <input
            type="range"
            min="0"
            max="100"
            value="40"
            class="range range-primary w-full"
          />
        </div>
      }
      -->
  </div>
}
